// import { useState } from "react";
// import BigPopUp from "./bigPopUp";
// import css from "./product.module.css";

// export default function WhyNeedRead({ oneProd }) {
//   const [popVisible, setPopVisible] = useState(false);
//   const [dataForPop, setDataForPop] = useState("");

//   const bipPopUp = (el) => {
//     setPopVisible(true);
//     setDataForPop(el);
//   };

//   return (
//     <div className={css.whyNeedWrapp}>
//       <div className={css.whyNeedWrappSmall}>
//         <h2 className={css.whyNeedH2}>Чому варто читати цю книгу? </h2>
//         <div className={css.whyNeedBlock}>
//           <div className={css.blockWhy}>{oneProd.whyNeedReadO}</div>
//           <div className={css.blockWhy}>{oneProd.whyNeedReadT}</div>
//           <div className={css.blockWhy}>{oneProd.whyNeedReadTH}</div>
//         </div>
//         <div className={css.wrapRecent}>
//           <div className={css.startText}>
//             {oneProd &&
//               oneProd.labelOneText &&
//               oneProd.labelOneText.length > 1 && (
//                 <div
//                   className={css.startTextFirst}
//                   onClick={() => bipPopUp(oneProd.labelOneText)}
//                 >
//                   {oneProd.labelOneName}
//                 </div>
//               )}
//             {oneProd &&
//               oneProd.labelTwoText &&
//               oneProd.labelTwoText.length > 1 && (
//                 <div
//                   className={css.startTextSecond}
//                   onClick={() => bipPopUp(oneProd.labelTwoText)}
//                 >
//                   {oneProd.labelTwoName}
//                 </div>
//               )}
//             {oneProd &&
//               oneProd.labelThreText &&
//               oneProd.labelThreText.length > 1 && (
//                 <div
//                   className={css.startTextThree}
//                   onClick={() => bipPopUp(oneProd.labelThreText)}
//                 >
//                   {oneProd.labelThreName}
//                 </div>
//               )}
//           </div>
//           <div className={css.startText}>
//             {oneProd &&
//               oneProd.labelFourName &&
//               oneProd.labelFourName.length > 1 && (
//                 <div
//                   className={css.startTextSecondFirst}
//                   onClick={() => bipPopUp(oneProd.labelFourText)}
//                 >
//                   {oneProd.labelFourName}
//                 </div>
//               )}
//             {oneProd &&
//               oneProd.labelFiveText &&
//               oneProd.labelFiveText.length > 1 && (
//                 <div
//                   className={css.startTextSecondSecond}
//                   onClick={() => bipPopUp(oneProd.labelFiveText)}
//                 >
//                   {oneProd.labelFiveName}
//                 </div>
//               )}
//           </div>
//         </div>
//       </div>
//       {popVisible && (
//         <BigPopUp dataForPop={dataForPop} setPopVisible={setPopVisible} />
//       )}
//     </div>
//   );
// }
import { useState } from "react";
import BigPopUp from "./bigPopUp";
import css from "./product.module.css";

export default function WhyNeedRead({ oneProd }) {
  const [popVisible, setPopVisible] = useState(false);
  const [dataForPop, setDataForPop] = useState("");

  const hasRealText = (value) => {
    if (value === null || value === undefined) return false;

    return (
      String(value)
        .replace(/\u00A0/g, " ")
        .trim().length > 0
    );
  };

  const bipPopUp = (el) => {
    if (!hasRealText(el)) return;

    setPopVisible(true);
    setDataForPop(el);
  };

  const labels = [
    {
      name: oneProd?.labelOneName,
      text: oneProd?.labelOneText,
      className: css.startTextFirst,
      row: 1,
    },
    {
      name: oneProd?.labelTwoName,
      text: oneProd?.labelTwoText,
      className: css.startTextSecond,
      row: 1,
    },
    {
      name: oneProd?.labelThreName,
      text: oneProd?.labelThreText,
      className: css.startTextThree,
      row: 1,
    },
    {
      name: oneProd?.labelFourName,
      text: oneProd?.labelFourText,
      className: css.startTextSecondFirst,
      row: 2,
    },
    {
      name: oneProd?.labelFiveName,
      text: oneProd?.labelFiveText,
      className: css.startTextSecondSecond,
      row: 2,
    },
  ];

  const firstRowLabels = labels.filter(
    (label) =>
      label.row === 1 && hasRealText(label.name) && hasRealText(label.text),
  );

  const secondRowLabels = labels.filter(
    (label) =>
      label.row === 2 && hasRealText(label.name) && hasRealText(label.text),
  );

  if (!oneProd) return null;

  return (
    <div className={css.whyNeedWrapp}>
      <div className={css.whyNeedWrappSmall}>
        <h2 className={css.whyNeedH2}>Чому варто читати цю книгу?</h2>

        <div className={css.whyNeedBlock}>
          {hasRealText(oneProd.whyNeedReadO) && (
            <div className={css.blockWhy}>{oneProd.whyNeedReadO}</div>
          )}

          {hasRealText(oneProd.whyNeedReadT) && (
            <div className={css.blockWhy}>{oneProd.whyNeedReadT}</div>
          )}

          {hasRealText(oneProd.whyNeedReadTH) && (
            <div className={css.blockWhy}>{oneProd.whyNeedReadTH}</div>
          )}
        </div>

        <div className={css.wrapRecent}>
          {firstRowLabels.length > 0 && (
            <div className={css.startText}>
              {firstRowLabels.map((label, index) => (
                <div
                  key={`${label.name}-${index}`}
                  className={label.className}
                  onClick={() => bipPopUp(label.text)}
                >
                  {label.name}
                </div>
              ))}
            </div>
          )}

          {secondRowLabels.length > 0 && (
            <div className={css.startText}>
              {secondRowLabels.map((label, index) => (
                <div
                  key={`${label.name}-${index}`}
                  className={label.className}
                  onClick={() => bipPopUp(label.text)}
                >
                  {label.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {popVisible && (
        <BigPopUp dataForPop={dataForPop} setPopVisible={setPopVisible} />
      )}
    </div>
  );
}
